import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../DataProviders/AppStateProvider';
import { useNavigation } from '../../Handler/NavigationHandler';

/**
 * Restart Button
 *
 * @param children
 * @param route
 * @returns {JSX.Element}
 * @constructor
 */
const RestartButton = ({ children, journey }) => {
  const { appData, updateAppData } = useContext(AppContext);
  const { handleStepClick, getNextStep } = useNavigation();
  const defaultJourney = journey || '_default';
  const nextStepKey = Object.keys(appData.journeys[defaultJourney])[0];

  // Change the destination on click to the default (restart)
  const handleRestartClick = (e) => {
    e.preventDefault();

    updateAppData({
      'currentJourney': defaultJourney,  // Update current route to the new journey
      'currentStep': nextStepKey
    });
  }

  // We need a useEffect because of asynchronous behaviour, we need to wait for the change of the
  // context before we start a navigation.
  useEffect(() => {
    if (appData.currentStep === nextStepKey) {
      handleStepClick(nextStepKey);
    }
  }, [appData.currentStep]);

  return (
    <a className="link" href="#" onClick={handleRestartClick}>{children}</a>
  );
}

export default RestartButton;
